<div
  #hotspotsContainer
  class="container-point"
  (mousedown)="onContainerMousedown($event)">
  <div class="background-wrapper" [class.image-background]="hotspots.background.mediaImage">

    <div class="widget-background">
      @if (hotspots.background.mediaImage) {
        <img
          class="background-media"
          [cropImage]="(hotspots.background.mediaImage | preSignedUrl | async) || hotspots.background.mediaImage?.url"
          [crop]="hotspots?.background?.mediaImage?.crop"
          [additionalOptions]="hotspots?.background?.mediaImage?.additionalMediaProps"
          (load)="onBackgroundLoad()"
          alt="Hotspot background image">
      }

      @if (hotspots.background.mediaVideo) {
        <lib-video
          class="background-media"
          #backgroundVideo
          [hideControls]="true"
          [src]="hotspots.background.mediaVideo | videoPresign | async"
          [loop]="hotspots.videoBehaviour === hotspotVideoBehaviour.LOOP"
          [autoplay]="autoplay"
          (videoDurationInitialized)="onBackgroundLoad()"
          (ended)="onVideoEnded()"
          (paused)="onVideoEnded()">
        </lib-video>
      }
    </div>

    @if (hotspots.background.mediaVideo) {
      <div class="video-actions" (mousedown)="$event.stopPropagation()">
        @if (hotspots.videoBehaviour === hotspotVideoBehaviour.LAST_FRAME && showMarkers) {
          <button
            mat-icon-button
            class="button button--icon button--icon-extra-small"
            (click)="replayVideo()">
            <lib-icon icon="arrow-counter-clockwise"></lib-icon>
          </button>
        }
        <button mat-icon-button class="button button--icon button--icon-extra-small" (click)="toggleVideoMute()">
          <lib-icon [icon]="backgroundVideoComponent?.plyr?.muted ? 'speaker-slash' : 'speaker-high'"></lib-icon>
        </button>
      </div>
    }

    <div cdkDropList cdkDropListSortingDisabled [cdkDropListDisabled]="!allowDrag">
      @for (point of hotspots.clickspots; track trackByFn(i, point); let i = $index) {
        <lib-hotspot-marker
          class="hotspot-marker"
          cdkDrag
          [cdkDragBoundary]="hotspotsContainer"
          [class.hidden]="!showMarkers"
          [ngStyle]="{'transition-delay': ((i + 1) * 200) + 'ms'}"
          [spotsAnimation]="hotspots?.spotsAnimation"
          [animate]="showMarkers"
          [attr.id]="'clickspot-button-' + id + '-' + i"
          [color]="point.backgroundColor ?? hotspots.fillColor"
          [iconColor]="point.iconColor"
          [border]="point.border"
          [blur]="point.backgroundBlur"
          [type]="hotspots.clickspotType"
          [activeStyle]="point.active"
          [selected]="(showCorrectAnswer && !disableCorrectSelection && point.correctAnswer) || (selectedHash && (selectedHash === point.hash))"
          [visited]="point.visited"
          [resizable]="resizable"
          [index]="i"
          [width]="point.width"
          [height]="point.height"
          [x]="point.x * 100"
          [y]="point.y * 100"
          [fillColor]="hotspots.fillColor"
          [hotspotBorderStyle]="hotspots.borderStyle"
          [borderColor]="hotspots.borderColor"
          [icon]="point.icon"
          [layout]="layout || hotspots.layout"
          [active]="activeClickSpotIndex === i"
          [showEditButton]="showEditButton"
          [matMenuTriggerFor]="showQuestionMenu && bundle === types.QUESTION_HOTSPOTS && actionMenu"
          [matMenuTriggerData]="{ index: i }"
          (sizeChanged)="sizeChanged.emit($event)"
          (edit)="edit.emit(i)"
          (markerClick)="toggleModal(i)"
          (mousedown)="$event.stopPropagation()"
          (cdkDragStarted)="onCdkDragStarted()"
          (cdkDragEnded)="onCdkDragEnded($event, i)">
          <ng-template cdkDragPlaceholder></ng-template>
        </lib-hotspot-marker>
        <mat-menu #actionMenu="matMenu" class="menu-panel-white">
          @if (!disableCorrectSelection) {
            <button mat-menu-item class="button" (click)="toggleCorrect.emit(i)">
              <lib-icon icon="check-circle"></lib-icon>
              <span>{{ (hotspots.clickspots[i]?.correctAnswer ? 'QUIZ_RESULTS.mark_as_incorrect' : 'QUIZ_RESULTS.mark_as_correct') | translate }}</span>
            </button>
          }
          <button mat-menu-item class="button" (click)="remove.emit(i)">
            <lib-icon icon="trash"></lib-icon>
            <span>{{'COMMON.delete' | translate}}</span>
          </button>
        </mat-menu>
      }
    </div>
  </div>

  @for (point of hotspots.clickspots; track trackByFn(i, point); let i = $index) {
    <lib-hotspot-content
      [hotspot]="point"
      [border]="hotspots.border"
      [removeDropShadows]="hotspots.dropShadow"
      [index]="i"
      [id]="id"
      [isTranslation]="isTranslation"
      [langcode]="langcode"
      [spacing]="spacing">
    </lib-hotspot-content>
  }

</div>
